import React from 'react';
import { Navigate } from 'react-router-dom';
export function useAuthGuard(_a) {
    var context = _a.context, children = _a.children, loader = _a.loader, redirectTo = _a.redirectTo;
    var _b = React.useContext(context), isInitialized = _b.isInitialized, isAuthenticated = _b.isAuthenticated;
    if (!isInitialized) {
        return loader || React.createElement(React.Fragment, null);
    }
    if (!isAuthenticated && redirectTo) {
        return React.createElement(Navigate, { to: redirectTo, replace: true });
    }
    return React.createElement(React.Fragment, null, children);
}
